import React from 'react';
import SectionTitle from './SectionTitle';
import SectionSubTitle from './SectionSubTitle';
import SectionSubContainer from './SectionSubContainer';

export default ({ status, delivered_at }) => {
  let title = 'Delivered';
  let bubble = 'placeholder';
  let subSection = null;
  let titleColor = '#b4b4b4';

  switch (status) {
    case 'received':
    case 'accepted':
    case 'not-shipped':
    case 'shipped':
      title = 'Delivered';
      bubble = 'placeholder';
      break;

    case 'not-delivered':
      title = 'Not delivered';
      bubble = 'warning';
      subSection = <SectionSubTitle>Check your emails</SectionSubTitle>;

    case 'delivered':
      title = 'Delivered';
      bubble = 'checkmark';
      titleColor = 'black';
      subSection = <SectionSubTitle>{delivered_at}</SectionSubTitle>;
      break;
  }

  return (
    <>
      <SectionTitle bubble={bubble} color={titleColor}>&nbsp;</SectionTitle>
      <span className="pt-2">
        <SectionTitle bubble={bubble} color={titleColor} hidden={true}>
          {title}
        </SectionTitle>
        <SectionSubContainer last>{subSection}</SectionSubContainer>
      </span>

    </>
  );
};
